export default __webpack_public_path__ + "static/robotlogo-ab1f5d284516d31b2513b37672155847.png";